import { render, staticRenderFns } from "./ClearCacheDialog.vue?vue&type=template&id=48c2ae54&"
import script from "./ClearCacheDialog.vue?vue&type=script&lang=js&"
export * from "./ClearCacheDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports